var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiSwitch from '@material-ui/core/Switch';
/**
 * Kareo wrapped component of the Material-ui Switch. The prop API has been limited to props defined in SwitchProps.
 *
 * Switches toggle the state of a single setting on or off.
 *
 * Material-UI Switch: [Docs](https://v4.mui.com/components/switches/), [API](https://v4.mui.com/api/switch/)
 *
 * @storybook: [Switch](http://design.kareoprod.ent/design-system/?path=/story/components-inputs--switch)
 */
var Switch = React.forwardRef(function (props, ref) {
    return React.createElement(MuiSwitch, __assign({}, props, { ref: ref }));
});
Switch.displayName = 'KareoSwitch';
export default Switch;
